import React, { forwardRef } from 'react';
import SupportPairedWithText from '../text-pairing/Support';
const Support = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("g", { fill: "currentColor" },
        React.createElement("path", { className: "ignore-direction", d: "M11.025 13.275v-.3c.075-1.725.3-2.25 2.025-3.75.675-.6 1.05-1.275 1.05-1.95C14.1 6 13.125 5.4 12.075 5.4c-1.125 0-2.25.675-2.25 2.475H8.25c0-2.475 2.025-3.75 3.9-3.75 1.8 0 3.6 1.05 3.6 3.075 0 2.625-3.3 3.075-3.3 5.7v.3h-1.425zm-.15 3.15v-1.8h1.8v1.8z" }),
        React.createElement("path", { d: "M0 0v24h3.3l3-3H24V0zm2.7 22.5H1.5v-21h21v18H5.7z" })))));
Support.displayName = 'Support';
// @ts-ignore;
const iconData = {
    glyph: Support,
    group: 'basic',
    textPairingGlyph: SupportPairedWithText,
    followDirection: true,
};
export default iconData;
